import React, { useEffect, useState } from 'react';
import api from '../services/api';

export default function WACloudQuality() {
  const [loading, setLoading] = useState(true);
  const [quality, setQuality] = useState('UNKNOWN');
  const [tier, setTier] = useState('TIER_1');
  const [logs, setLogs] = useState([]);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        setLoading(true);
        const r = await api.waCloud.getQualityAndLimits();
        if (!mounted) return;
        setQuality(r?.quality ?? 'UNKNOWN');
        setTier(r?.limitTier ?? 'TIER_1');
        setLogs(r?.recentLogs ?? []);
      } catch (e) {
        if (mounted) setMsg(`Error: ${e.message}`);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, []);

  return (
    <div style={{ padding: 16 }}>
      <h2>WA Cloud: Calidad & Límites</h2>
      <div style={{ marginBottom: 12 }}>
        <a href="/connect/whatsapp-cloud">← Volver al Wizard</a>
      </div>

      {loading && <div>Cargando…</div>}

      {!loading && (
        <div style={{ display: 'grid', gap: 16 }}>
          <div style={{ border: '1px dashed #ccc', borderRadius: 8, padding: 12 }}>
            <strong>Indicadores</strong>
            <div style={{ marginTop: 8 }}>Calidad: <code>{quality}</code></div>
            <div style={{ marginTop: 4 }}>Límite: <code>{tier}</code></div>
          </div>

          <div style={{ border: '1px dashed #ccc', borderRadius: 8, padding: 12 }}>
            <strong>Logs recientes</strong>
            {logs.length === 0 ? (
              <div style={{ marginTop: 8 }}>Sin eventos (mock).</div>
            ) : (
              <ul style={{ marginTop: 8 }}>
                {logs.map((l, i) => <li key={i}>{l}</li>)}
              </ul>
            )}
          </div>

          <div style={{ border: '1px dashed #ccc', borderRadius: 8, padding: 12 }}>
            <strong>Buenas prácticas</strong>
            <ul style={{ marginTop: 8 }}>
              <li>Usa plantillas aprobadas y relevantes.</li>
              <li>Mantén una buena tasa de respuesta del cliente.</li>
              <li>Evita spam y respeta políticas de Meta.</li>
            </ul>
          </div>
        </div>
      )}

      {msg && <div style={{ marginTop: 12, padding: 8, border: '1px solid #eee' }}>{msg}</div>}
    </div>
  );
}